import React, { useEffect } from "react";
import MyRouter from "routers/index";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  setDapp,
  setParticipants,
  setParticipant,
  setBalance,
  dAppIsLoaded,
  setWinnerBet,
  setIsActive,
  setEnabledCountries,
} from "dApp/reducer";
import dApp from "dApp/class";

declare global {
  interface Window {
    ethereum: any;
    hbspt: any;
  }
}

function App() {
  const _dAppIsLoaded = useAppSelector(dAppIsLoaded);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!_dAppIsLoaded) {
      dApp.build().then((app) => {
        app.onNewBet((wallet: string) => {
          app
            .getBalance()
            .then((b) => {
              console.log(b);
              dispatch(setBalance(b));
            })
            .catch((error: any) => {
              console.log(error, "getBalance");
            });
          app
            .getparticipant(wallet)
            .then((p) => {
              dispatch(setParticipant(p));
            })
            .catch((error: any) => {
              console.log(error, "getparticipant");
            });
        });
        dispatch(setDapp(app));
        app.getparticipants().then(({ participants, total }) => {
          dispatch(setParticipants({ participants, total }));
        });
        app.getWinnerBet().then(({ winner, ratio }) => {
          if (winner) dispatch(setWinnerBet({ winner, ratio }));
        });
        app.isActive().then((isActive) => {
          dispatch(setIsActive(isActive));
        });
        app.getAllCountries().then((countries) => {
          dispatch(setEnabledCountries(countries));
        });
      }).catch((error: any) => {
        console.error("dApp.build() failed:", error);
      });
    }
  }, [_dAppIsLoaded, dispatch]);

  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <MyRouter />
    </div>
  );
}

export default App;
